import type { OpenEndedResponse } from '../types';

/* Note! Updates to this value needs to be reflected in core-api maxItemsPerPageCount */
const NR_OF_RESPONSES_PER_PAGE = 8;

const getPagination = (page: number) => {
  const fromIndex = page * NR_OF_RESPONSES_PER_PAGE;
  const toIndex = fromIndex + NR_OF_RESPONSES_PER_PAGE;
  return [fromIndex, toIndex];
};

export const getPaginatedResults = (
  results: OpenEndedResponse[],
): OpenEndedResponse[] => {
  const url = new URL(window.location.href);
  // Only paginate by query string for screenshot service
  const page = parseInt(url.searchParams.get('p') ?? '0', 10);
  // Set visible items
  const [fromIndex, toIndex] = getPagination(page);
  return results.slice(fromIndex, toIndex);
};
